import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { OldSolutionsSection } from './components/OldSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <OldSolutionsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatsInsideSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <GuaranteeSection data-id="element-7" />
      <FinalCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}